import PropTypes from 'prop-types';
import prepareTranslate from '@/helpers/dictionary';
import s3Mutations from '@/api/mutitations/s3';
import { useState } from 'react';
import agentMutate from '@/api/mutitations/agent';
import { Button, Flex } from '@mantine/core';
import EditFiles from '../EditFiles';

const EditDocuments = (props) => {
  const {
    files,
    setFiles,
    agentId,
    openModal,
    setModalLabel,
    setKey,
  } = props;

  const t = prepareTranslate();

  const { useUpload } = s3Mutations;
  const { mutateAsync: uploadMutate } = useUpload();
  const { mutateAsync: addFileToAgent } = agentMutate.usePushToArray();
  const [loading, setLoading] = useState(false);

  const onFileNameChange = (index, newName) => {
    const updated = [...files];
    updated[index] = { ...updated[index], name: newName };
    setFiles(updated);
  };

  const onDeleteFile = (index) => {
    const updated = [...files];
    updated.splice(index, 1);
    setFiles(updated);
  };

  const uploadFiles = async () => {
    setLoading(true);
    if (files?.length > 0) {
      const formData = new FormData();

      files.forEach((file) => {
        const { file: fileData, name } = file;
        formData.append('files', fileData, name);
      });

      try {
        const uploadedFiles = await uploadMutate(formData);

        const uploadPromises = uploadedFiles.files.map((file) => {
          const data = {
            value: file,
            id: agentId,
            key: 'agentFiles',
          };
          return addFileToAgent(data);
        });
        await Promise.all(uploadPromises);

        setModalLabel(t('components.viewAgentFiles.uploadSuccess'));
        openModal();
        setKey((prev) => prev + 1);
        setFiles([]);
      } catch (error) {
        setModalLabel(t('components.viewAgentFiles.uploadError'));
        openModal();
      } finally {
        setLoading(false);
      }
    }
  };

  return (
<>
      <EditFiles
        files={files}
        onNameChange={onFileNameChange}
        onRemove={onDeleteFile}
       />
      <Flex m={'1rem 0'} gap={'0.5rem'}>
          <Button onClick={uploadFiles} loading={loading}>{t('components.viewAgentFiles.upload') }</Button>
          <Button variant='outline' onClick={() => setFiles([])}>{t('global.cancel') }</Button>
      </Flex>
    </>
  );
};

EditDocuments.propTypes = {
  files: PropTypes.array,
  setFiles: PropTypes.func,
  agentId: PropTypes.string,
  openModal: PropTypes.func,
  setModalLabel: PropTypes.func,
  setKey: PropTypes.func,
};

export default EditDocuments;
